<section
  [ngClass]="{
    'clickable': foldable,
    'o-form-section': showTitle
    }"
>
  <h4 class="o-form-section-h section-header"
      *ngIf="showTitle"
      (click)="handleTitleClick()">{{sectionTitle}}</h4>
  <psei-button
    class="header-chevron"
    [tile]="true"
    [chevron]="true"
    *ngIf="foldable"
    [open]="defaultFold"
    [color]="'primary'"
    [pseiTooltip]="'Zaznacz wszystkie konta spełniające kryteria filtrowania'"
    (buttonClick)="handleTitleClick()"
  >
  </psei-button>
  <ng-container *ngIf="!foldable || !defaultFold">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between stretch"
      class="pb-bp-section-container"
      fxFill
    >
      <div
        [fxFlex]="doubleSection ? 50 : 100"
        fxFlexAlign="stretch"
      >
        <div
          [ngClass]="{'pb-bp-section-left' : showTitle}"
        >
          <ng-content>
          </ng-content>
        </div>
      </div>
      <div
        *ngIf="doubleSection"
        fxFlex="50"
        fxFlexAlign="stretch"
      >
        <div class="pb-bp-section-right">
          <ng-content select="[pbBpSectionRight]">
          </ng-content>
        </div>
      </div>
    </div>
  </ng-container>
</section>
